export const CANONICAL_GAME_KEY = 'Canonical game info url';
export const REG_EXP = /\/igaming\/games-info\/|\/online-game\//;

export const EVENT_UPDATE_DOM = 'EVENT_UPDATE_DOM';
export const DELAY_UPDATE_DOM = 300;
export const DELAY_SCROLL_TO_PARAGRAPH = 500;
export const WAITING_UPDATE_DOM = 5000;
export const PLAYER_TAG_IDV_UPLOADED = 'Exportable/IDV Uploaded';
export const PLAYER_TAG_IDV_CHECKED = 'Exportable/IDV Checked';

export enum DEVICES {
    mobile = 'mobile',
    desktop = 'desktop',
    tablet = 'tablet',
}

export enum USER_ROLES {
    admin = 'admin',
    user = 'user',
    guest = 'guest',
}
